<template>
  <div>
    <InstallmentSimulation v-if="paymentMethod" :base-price :payment-method />

    <PaymentGroupMessages v-if="paymentGroup" :group="paymentGroup" />

    <slot />
  </div>
</template>

<script lang="ts" setup>
import InstallmentSimulation from '../../../../advertising/components/InstallmentSimulation/InstallmentSimulation.vue'
import PaymentGroupMessages from '../../PaymentFormGroupMessages/PaymentFormGroupMessages.vue'
import type { PaymentFormAdornmentProps } from '../PaymentFormAdornment.type'

defineProps<PaymentFormAdornmentProps>()
</script>
